const FONTS = [
  {
    vfsName: 'PTSans-Regular.ttf',
    style: 'normal',
    url: new URL('../assets/fonts/PT_Sans-Web-Regular.ttf', import.meta.url).href
  },
  {
    vfsName: 'PTSans-Bold.ttf',
    style: 'bold',
    url: new URL('../assets/fonts/PT_Sans-Web-Bold.ttf', import.meta.url).href
  },
  {
    vfsName: 'PTSans-Italic.ttf',
    style: 'italic',
    url: new URL('../assets/fonts/PT_Sans-Web-Italic.ttf', import.meta.url).href
  }
];

const base64Cache = new Map();

async function loadBase64(url) {
  if (base64Cache.has(url)) return base64Cache.get(url);
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`Не удалось загрузить шрифт: ${resp.status} ${resp.statusText}`);
  const bytes = new Uint8Array(await resp.arrayBuffer());
  let binary = '';
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
  }
  const base64 = btoa(binary);
  base64Cache.set(url, base64);
  return base64;
}

// Встраивает PT Sans (кириллица) в jsPDF-документ; OOXML-шрифты jsPDF (helvetica) не покрывают кириллицу
export async function registerPdfFont(doc) {
  for (const font of FONTS) {
    const base64 = await loadBase64(font.url);
    doc.addFileToVFS(font.vfsName, base64);
    doc.addFont(font.vfsName, 'PTSans', font.style);
  }
}